import { render } from "./BuyerItem.vue?vue&type=template&id=bcfef3a4&scoped=true"
import script from "./BuyerItem.vue?vue&type=script&lang=js"
export * from "./BuyerItem.vue?vue&type=script&lang=js"

import "./BuyerItem.vue?vue&type=style&index=0&id=bcfef3a4&lang=scss&scoped=true"

import exportComponent from "/root/workspace/bjyx-h5_Pbc0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bcfef3a4"]])

export default __exports__